import { AWSServiceType } from "../../../../../utils/constants";
import { internetExposureOption } from "../serverFilters";
import { filterName } from "../utils";
import {
  areAllFiltersNotApplied,
  areHighRisksApplied,
  createEmptyFilters,
  EDRTools,
  highRisksOptions,
  isMissingEDRApplied,
} from "./utils";

export const getServerSmartFiltersInfo = (
  fetchedEntities,
  appliedFilters,
  setAppliedFilters
) => {
  const exposedToInternetApplied =
    appliedFilters[filterName.INTERNET_EXPOSURE]?.[
      internetExposureOption.EXPOSED
    ] &&
    Object.entries(appliedFilters[filterName.INTERNET_EXPOSURE])
      .filter(([option, _]) => option !== internetExposureOption.EXPOSED)
      .every(([_, checked]) => !checked);

  const isEC2Applied =
    appliedFilters[filterName.SERVER_TYPE]?.[AWSServiceType.EC2] &&
    Object.entries(appliedFilters[filterName.SERVER_TYPE])
      .filter(([type, _]) => type !== AWSServiceType.EC2)
      .every(([_, checked]) => !checked);

  return [
    {
      text: "Server at high risk exposed to the internet",
      applied:
        areHighRisksApplied(appliedFilters) &&
        exposedToInternetApplied &&
        areAllFiltersNotApplied({
          appliedFilters: appliedFilters,
          excludedFilterNames: [filterName.RISK, filterName.INTERNET_EXPOSURE],
        }),
      onClick: () => {
        const updatedFilters = createEmptyFilters(appliedFilters);
        highRisksOptions.forEach((risk) => {
          updatedFilters[filterName.RISK][risk] = true;
        });
        updatedFilters[filterName.INTERNET_EXPOSURE] = {
          [internetExposureOption.EXPOSED]: true,
        };
        setAppliedFilters(updatedFilters);
      },
    },
    {
      text: "Server missing EDR",
      applied:
        isMissingEDRApplied(fetchedEntities, appliedFilters) &&
        isEC2Applied &&
        areAllFiltersNotApplied({
          appliedFilters: appliedFilters,
          excludedFilterNames: [
            filterName.EXCLUDE_SOURCE,
            filterName.SERVER_TYPE,
          ],
        }),
      onClick: () => {
        const updatedFilters = createEmptyFilters(appliedFilters);
        updatedFilters[filterName.EXCLUDE_SOURCE] = Object.fromEntries(
          EDRTools.map((tool) => [tool, true])
        );
        updatedFilters[filterName.SERVER_TYPE] = {
          [AWSServiceType.EC2]: true,
        };
        setAppliedFilters(updatedFilters);
      },
    },
  ];
};
